export const STATEMENT_PAGE_LIMIT = 8
export const STATEMENT_PAGE_MAX_BYTES = 10 * 1024 * 1024

export const STATEMENT_PAGE_ACCEPT = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/heic',
  'image/heif',
  '.pdf',
  '.jpg',
  '.jpeg',
  '.png',
  '.heic',
  '.heif',
].join(',')

const EXTENSIONS = new Set(['pdf', 'jpg', 'jpeg', 'png', 'heic', 'heif'])
const MIMES = new Set([
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/heic',
  'image/heif',
  'image/heic-sequence',
  'image/heif-sequence',
])

export type StatementPageIssue = 'type' | 'size'

export const STATEMENT_PAGE_TOO_LARGE = 'Each statement file must be 10 MB or smaller.'
export const STATEMENT_PAGE_WRONG_TYPE = 'Wrong file type. Use a PDF, JPEG, PNG, or HEIC photo.'
export const STATEMENT_PAGE_TOO_MANY = 'Upload at most 8 photos for one statement.'

export function statementPageIssue(file: File): StatementPageIssue | null {
  if (file.size > STATEMENT_PAGE_MAX_BYTES) {
    return 'size'
  }
  if (!acceptedStatementPage(file)) {
    return 'type'
  }
  return null
}

export function statementPageIssueMessage(issue: StatementPageIssue): string {
  return issue === 'size' ? STATEMENT_PAGE_TOO_LARGE : STATEMENT_PAGE_WRONG_TYPE
}

function acceptedStatementPage(file: File): boolean {
  const extension = file.name.split('.').pop()?.toLowerCase() ?? ''
  const mime = file.type.trim().toLowerCase()
  const extensionOk = EXTENSIONS.has(extension)
  const mimeOk = MIMES.has(mime)
  if (mime === '' || mime === 'application/octet-stream') {
    return extensionOk
  }
  if (extensionOk && !mimeOk) {
    return false
  }
  return mimeOk || extensionOk
}
